import { makeGraphqlRequestCloud } from 'api/graphql/graphQLClient';
import { SampleFull } from '@/graphql/cloud/samples/queries/SampleFull.graphql';
import { SamplesShort } from '@/graphql/cloud/samples/queries/SamplesShort.graphql';
import { CreateSampleForQuickStart } from '@/graphql/cloud/samples/mutations/CreateSampleForQuickStart.graphql';
import { SampleQuantity } from '@/graphql/cloud/samples/queries/SampleQuantity.graphql';
import { RemoveSample } from '@/graphql/cloud/samples/mutations/RemoveSample.graphql';
import { SampleBrief as SubscriptionForSampleBrief } from '@/graphql/cloud/samples/subscription/SampleBrief.graphql';
import { transformArrayToObject } from '@/utils/objectHelpers';
import DataNotFoundError from '@/errors/DataNotFoundError';
import { subscribe } from '@/api/graphql/wsHasuraClient';

export const apiSamples = {
  async getSampleFull(id, sharedToken) {
    const { sample: sampleFull } = await makeGraphqlRequestCloud(
      SampleFull,
      { id },
      1,
      sharedToken,
      id,
    );

    if (!sampleFull) {
      throw new DataNotFoundError();
    }

    const { device, injections, column, method, user, ...sample } = sampleFull;

    return {
      device,
      injections: transformArrayToObject(
        injections.map(({ device, column, method, ...injection }) => ({
          id: injection.id,
          device,
          column,
          method,
          injection: {
            ...injection,
            measurements: transformArrayToObject(injection.measurements, 'id'),
          },
        })),
        'id',
      ),
      column,
      method,
      user,
      sample: {
        ...sample,
        device_name: device?.name,
      },
    };
  },
  async getSamples({ search = '', isArchived = false, offset = 0, limit }) {
    const { samples, samples_aggregate } = await makeGraphqlRequestCloud(SamplesShort, {
      search: `%${search ?? ''}%`,
      isArchived,
      offset,
      limit,
    });

    return {
      samples,
      count: samples_aggregate.aggregate.count,
    };
  },

  async getSampleQuantity() {
    const {
      samples_aggregate: {
        aggregate: { count },
      },
    } = await makeGraphqlRequestCloud(SampleQuantity);
    return count;
  },
  async createSample(name) {
    const { sample } = await makeGraphqlRequestCloud(CreateSampleForQuickStart, { name });
    return sample;
  },
  removeSample(id) {
    return makeGraphqlRequestCloud(RemoveSample, { id });
  },

  subscribeForSampleBrief(id, onSampleBrief, sharedToken) {
    return subscribe(
      SubscriptionForSampleBrief,
      { id },
      ({ sample }) => {
        onSampleBrief({
          ...sample,
          device_name: sample.device?.name,
        });
      },
      sharedToken,
      id,
    );
  },
};
